import { FormatDetectionResult } from 'utils/universalCsvParser';
import MagicButton from 'components/MagicButton';

interface ConditionStepProps {
  cardCount: number;
  format: FormatDetectionResult | null;
  selectedCondition: string;
  onConditionChange: (condition: string) => void;
  onContinue: () => void;
}

const CONDITIONS = [
  { value: 'NEAR_MINT', label: 'Near Mint', abbrev: 'NM' },
  { value: 'LIGHTLY_PLAYED', label: 'Lightly Played', abbrev: 'LP' },
  { value: 'MODERATELY_PLAYED', label: 'Moderately Played', abbrev: 'MP' },
];

const ConditionStep = ({
  cardCount,
  format,
  selectedCondition,
  onConditionChange,
  onContinue,
}: ConditionStepProps) => {
  const formatDisplayName = format?.format
    ? format.format.charAt(0).toUpperCase() + format.format.slice(1)
    : 'Unknown';

  return (
    <div className="condition-step">
      <div className="condition-step-header">
        <h2>Select Card Condition</h2>
        <p className="condition-step-description">
          Your import contains <span className="condition-step-highlight">{cardCount.toLocaleString()} cards</span>
          {format && format.format !== 'generic' && (
            <>
              {' '}from <strong>{formatDisplayName}</strong>
            </>
          )}
        </p>
        <p className="condition-step-note">
          Select the default condition for all cards. You can edit individual cards later from your
          Collection page.
        </p>
      </div>

      <div className="condition-options">
        {CONDITIONS.map((condition) => (
          <button
            key={condition.value}
            className={`condition-option ${selectedCondition === condition.value ? 'selected' : ''}`}
            onClick={() => onConditionChange(condition.value)}
            type="button"
          >
            <span className="condition-label">{condition.label}</span>
            <span className="condition-abbrev">{condition.abbrev}</span>
          </button>
        ))}
      </div>

      <div className="condition-step-actions">
        <MagicButton
          label={`Continue with ${cardCount.toLocaleString()} cards →`}
          color="purple"
          onPress={onContinue}
        />
      </div>
    </div>
  );
};

export default ConditionStep;
